// GiftCertificate/GiftCertificateDetail.tsx

import React from 'react';
import {useTheme} from 'Theme/ThemeContext';
import Button from 'Core/components/elements/Button/Button';
import {FC, FR} from 'WideLayout/Layouts';
import {useNavigate} from 'react-router-dom';
import {IGiftCertificate} from "Types/commerce/gift_certificate";

interface GiftCertificateDetailProps {
    giftCertificate: IGiftCertificate;
    cls?: string;
}

const GiftCertificateDetail: React.FC<GiftCertificateDetailProps> = (
    {
        giftCertificate,
        cls
    }) => {
    const {plt} = useTheme();
    const navigate = useNavigate();

    const price = parseInt(String(giftCertificate.prices[0]?.amount || 0));
    const currency = giftCertificate.prices[0]?.currency || '';
    const handleBuy = () => {
        navigate(`/order/gift-certificate/${giftCertificate.id}`, {state: {product: giftCertificate}});
    };

    return (
        <FC cls={`gift-certificate-detail ${cls}`} g={1} maxW={700} mx="auto">
            <h2>{giftCertificate.name}</h2>
            <FR color={plt.text.primary50}>{giftCertificate.description}</FR>
            <FR>Продукт: {giftCertificate.product.name}</FR>
            <Button
                className={'mt-2'}
                variant={'contained'}
                color={'primary'}
                onClick={handleBuy}
            >
                Купить за {price} {currency}
            </Button>
        </FC>
    );
};

export default GiftCertificateDetail;
